import { WSQueryConfig } from "@ws-react-query";
import {
  ApiQueryListWorkLogs,
  getWorkLogsSummary,
  IWorkLogsSummary
} from "../../../services/workLog";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";

export const QUERY_WORK_LOGS_SUMMARY = "QUERY_WORK_LOGS_SUMMARY";

export const useQueryWorkLogsSummary = (
  params?: ApiQueryListWorkLogs,
  config?: WSQueryConfig<IWorkLogsSummary, WSServiceError>
) => {
  return useWSQuery<IWorkLogsSummary, WSServiceError>(
    [QUERY_WORK_LOGS_SUMMARY, params],
    () =>
      getWorkLogsSummary({
        ...params,
        page: { size: 1, number: 1 }
      }),
    config
  );
};
